import axios from "axios";

export function shopEdit(businessData, type) {
  let id = businessData.businessId;
  var config = {
    method: "put",
    url: `${process.env.VUE_APP_APIHOST}/${type}/shops/${id}`,
    data: {
        businessData
    }
  };
  return axios(config);
}

export function updateRichmenu(accountId) {
  let configBusiness = {
    method: "put",
    url: `${process.env.VUE_APP_APIHOST}/gaa/line-accounts/${accountId}/richmenu`,
    data: data
  };
  return axios(configBusiness);
}

export function assignToSpecificSiAccount(data) {
  let configBusiness = {
    method: "put",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${data.shopId}/si-account`,
    data: data
  };
  return axios(configBusiness);
}

export function shopStatus(businessData, type) {
  let accountId = businessData.accountId;
  var config = {
    method: "put",
    url: `${process.env.VUE_APP_APIHOST}/${type}/shops/${accountId}/status`,
    data: {
        isEnabled: businessData.isEnabled
    }
  };
  return axios(config);
}


export function updateOrderLimit(type, accountId, id, data) {
  let config = {
    method: "patch",
    url: `${process.env.VUE_APP_APIHOST}/${type}/accounts/${accountId}/order-limits/${id}`,
    data: data
  };
  return axios(config);
}

export function updateLabelPrinter(businessId, disabledLabel, type) {
  let config = {
    method: "patch",
    url: `${process.env.VUE_APP_APIHOST}/${type}/accounts/${businessId}/label-printer`,
    data: {
      disabledLabel
    }
  };
  return axios(config);
}

export function accountToggle(accountId, key, value, label="") {
  let config = {
    method: "patch",
    url: `${process.env.VUE_APP_APIHOST}/gaa/accounts/${accountId}/account-toggle`,
    data: {
      key,
      value,
      label
    }
  };
  return axios(config);
}

export function businessToggle(accountId, key, value) {
  let config = {
    method: "patch",
    url: `${process.env.VUE_APP_APIHOST}/gaa/accounts/${accountId}/business-toggle`,
    data: {
      key,
      value
    }
  };
  return axios(config);
}

export function updatePrinterTemplateById(id, d) {
  let config = {
    method: "patch",
    url: `${process.env.VUE_APP_APIHOST}/gaa/printer-template/${id}`,
    data: d
  };
  return axios(config);
}

export function putGtmByAccounts(d) {
  let config = {
    method: "put",
    url: `${process.env.VUE_APP_APIHOST}/gaa/business/bulk/gtm`,
    data: d
  };
  return axios(config);
}

export function updateScanner(accountId, data, type) {
  let config = {
    method: 'PUT',
    url: `${process.env.VUE_APP_APIHOST}/${type}/shops/${accountId}/scanners/${data.sn}`,
    data
  }
  return axios(config);
}